// extracted by mini-css-extract-plugin
module.exports = {"bizLink":"MallOverviewDirectory_bizLink_2K0Ti"};